module.exports = __webpack_public_path__ + "img/pg1-bottom-bg.024d1046.png";